export function pickTransform(
  object: Record<string, any> | null | undefined,
  props: string[],
  cast: Record<string, (val: any) => any> = {}
): Record<string, any> | object {
  if (!object) return {};

  const result: Record<string, any> = {};

  for (const prop of props) {
    result[prop] = cast[prop] ? cast[prop](object[prop]) : object[prop];
  }

  return result;
}
